import { render } from "./TheHome.vue?vue&type=template&id=3b9445b6"
import script from "./TheHome.vue?vue&type=script&lang=js"
export * from "./TheHome.vue?vue&type=script&lang=js"

import "./TheHome.vue?vue&type=style&index=0&id=3b9445b6&lang=scss"

import exportComponent from "C:\\Projects\\svila\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__